import { Link } from 'react-router-dom';
import TutelaLogo from '../components/icons/TutelaLogo';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export default function Pilots() {
  useDocumentMeta(
    'Pilots | Tutela',
    'Tutela platform pilots under evaluation with public entities. First pilot: the Municipality of Vila Franca de Xira, with CIAITeX.',
    '/pilots',
    { alternates: { en: '/pilots', 'pt-PT': '/pilotos' } },
  );
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-ink-950 text-mist">
      <div className="mx-auto max-w-3xl px-6 py-20">
        <div className="mb-6 flex items-baseline justify-between">
          <div className="font-mono text-xs uppercase tracking-[0.28em] text-ember">Pilots</div>
          <Link
            to="/pilotos"
            className="font-mono text-xs uppercase tracking-widest text-mist-faint transition-colors hover:text-mist"
          >
            PT
          </Link>
        </div>

        <h1 className="font-display text-3xl font-bold tracking-tight text-mist sm:text-4xl">
          Evaluated in the field, with the people who decide
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-mist-muted">
          Tutela grows module by module, and each module is evaluated with real public entities
          before any promise is made. This page records those pilots, in the state they are
          actually in.
        </p>

        <div className="mt-14 space-y-12">
          <section className="border-t border-ink-800 pt-10">
            <h2 className="font-display text-2xl font-bold tracking-tight text-mist">
              Municipality of Vila Franca de Xira
            </h2>
            <div className="mt-4 space-y-3 leading-relaxed text-mist-muted">
              <p>
                A first pilot is under evaluation with the Municipality of Vila Franca de Xira
                (Câmara Municipal), within a research project of{' '}
                <span className="text-mist">CIAITeX</span>, the Municipal Centre for Artificial
                Intelligence, Innovation and Information Technologies.
              </p>
              <p>
                The pilot evaluates the{' '}
                <span className="text-mist">fuel-break management prioritisation</span> module:
                using the national LiDAR survey, cadastral mapping and open data, it ranks, by
                parish and by parcel, the situations worth verifying in the field. The
                prioritisation is indicative and supports fieldwork planning; it does not
                constitute detection of non-compliance and does not replace local technical
                assessment.
              </p>
              <p>Status: pilot under evaluation (2026).</p>
            </div>
          </section>

          <section className="border-t border-ink-800 pt-10">
            <h2 className="font-display text-2xl font-bold tracking-tight text-mist">
              Your municipality
            </h2>
            <div className="mt-4 space-y-3 leading-relaxed text-mist-muted">
              <p>
                We work with municipalities and other public entities on short pilots, over real
                territory and open data. If that sounds useful to your team, talk to us:{' '}
                <a
                  href="mailto:martim@neuralforge.pt"
                  className="font-medium text-ember hover:brightness-110"
                >
                  martim@neuralforge.pt
                </a>
                .
              </p>
            </div>
          </section>
        </div>

        <div className="mt-16 flex flex-wrap items-center gap-4 border-t border-ink-800 pt-8">
          <Link
            to="/ignis"
            className="inline-flex items-center gap-2 rounded-lg bg-ember px-6 py-3 font-semibold text-ink-950 shadow-[0_0_30px_-8px_#F26A4B] transition-all duration-200 hover:brightness-110"
          >
            Discover IGNIS
          </Link>
          <Link
            to="/sobre"
            className="inline-flex items-center gap-2 rounded-lg px-5 py-3 font-mono text-sm uppercase tracking-widest text-mist-muted transition-colors hover:text-mist"
          >
            About Tutela
          </Link>
          <span className="ml-auto opacity-60">
            <TutelaLogo className="h-8 w-8" variant="light" />
          </span>
        </div>
      </div>
    </div>
  );
}
